import React from "react";
import { motion } from "framer-motion";

const WebDevFlow = () => {
  return (
    <div className="serivces_flow" id="wrap">
      <div className="titles">
        <div className="wrapper">
          {/* <a href="javascript:void(0)" className="btn-blue">
            HEIGHTEN YOUR SPLENDOUR
          </a>
          <h3>Technology We Use</h3>
          <p>
            Reference site about Lorem Ipsum, giving informationon its origins,
            as well as a random Lipsum generator. Reference site about Lorem
            Ipsum, giving informationon its origins, as well as a random Lipsum
            generator.
          </p> */}
        </div>
      </div>
      <div className="wrapper">
        <div className="service_flow_wrap">
          <svg
            width="830"
            height="1112"
            viewBox="0 0 830 1112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 207.501C109.048 207.708 106.351 207.812 103.629 207.812C46.4674 207.812 0.128906 161.474 0.128906 104.312C0.128906 47.151 46.4674 0.8125 103.629 0.8125C124.168 0.8125 143.31 6.79531 159.407 17.1133C173.432 26.1034 188.868 33.8125 205.527 33.8125H554.129C602.178 33.8125 641.129 72.7637 641.129 120.812C641.129 168.861 602.178 207.812 554.129 207.812H119.129C116.632 207.812 114.16 207.707 111.717 207.501Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 207.003L111.718 207L111.678 207.003C109.022 207.208 106.338 207.312 103.629 207.312C46.7436 207.312 0.628906 161.198 0.628906 104.312C0.628906 47.4271 46.7436 1.3125 103.629 1.3125C124.07 1.3125 143.118 7.26633 159.137 17.5342C173.181 26.5359 188.718 34.3125 205.527 34.3125H554.129C601.902 34.3125 640.629 73.0398 640.629 120.812C640.629 168.585 601.902 207.312 554.129 207.312H119.129C116.646 207.312 114.188 207.208 111.759 207.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="103.629"
              cy="104.312"
              r="82.5"
              fill="url(#paint0_linear_113_511)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="104.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip0_113_511)">
              <path
                d="M92.2494 107.654C93.0263 106.763 92.3935 105.371 91.2112 105.371H87.6714C87.6484 105.021 87.6355 104.668 87.6355 104.312C87.6355 95.4926 94.8105 88.3175 103.63 88.3175C107.868 88.3175 111.726 89.9751 114.591 92.6753L119.582 86.8359C115.213 82.8388 109.59 80.6494 103.63 80.6494C97.3094 80.6494 91.3672 83.1108 86.8979 87.58C82.4287 92.0493 79.9673 97.9915 79.9673 104.312C79.9673 104.666 79.9762 105.019 79.9916 105.371H77.01C75.8277 105.371 75.1948 106.763 75.9718 107.654L82.6978 115.369L84.1105 116.989L89.1828 111.171L92.2494 107.654Z"
                fill="#1375B2"
              />
              <path
                d="M131.288 103.153L126.272 97.3986L123.15 93.8174L118.692 98.9304L115.011 103.153C114.234 104.044 114.867 105.436 116.049 105.436H119.585C119.006 113.733 112.072 120.307 103.63 120.307C99.9453 120.307 96.5478 119.054 93.8404 116.952L88.8486 122.792C93.0304 126.15 98.1897 127.975 103.63 127.975C109.951 127.975 115.893 125.514 120.362 121.045C124.566 116.841 126.993 111.334 127.266 105.436H130.25C131.432 105.436 132.065 104.044 131.288 103.153Z"
                fill="#1375B2"
              />
            </g>
            <g filter="url(#filter1_i_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 644.501C109.048 644.708 106.351 644.812 103.629 644.812C46.4674 644.812 0.128906 598.474 0.128906 541.312C0.128906 484.151 46.4674 437.812 103.629 437.812C124.168 437.812 143.31 443.795 159.407 454.113C173.432 463.103 188.868 470.812 205.527 470.812H554.129C602.178 470.812 641.129 509.764 641.129 557.812C641.129 605.861 602.178 644.812 554.129 644.812H119.129C116.632 644.812 114.16 644.707 111.717 644.501Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 644.003L111.718 644L111.678 644.003C109.022 644.208 106.338 644.312 103.629 644.312C46.7436 644.312 0.628906 598.198 0.628906 541.312C0.628906 484.427 46.7436 438.312 103.629 438.312C124.07 438.312 143.118 444.266 159.137 454.534C173.181 463.536 188.718 471.312 205.527 471.312H554.129C601.902 471.312 640.629 510.04 640.629 557.812C640.629 605.585 601.902 644.312 554.129 644.312H119.129C116.646 644.312 114.188 644.208 111.759 644.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="103.629"
              cy="541.312"
              r="82.5"
              fill="url(#paint1_linear_113_511)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="541.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip1_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M95.9922 558.44C90.1909 558.44 84.6895 557.619 80.5015 556.128C78.5387 555.429 76.9076 554.597 75.6417 553.65C75.6417 553.65 75.6416 560.633 75.6416 561.066C75.6416 565.068 84.7529 568.312 95.9922 568.312C107.232 568.312 116.343 565.068 116.343 561.066V553.65C115.077 554.597 113.446 555.429 111.483 556.128C107.295 557.619 101.794 558.44 95.9922 558.44Z"
                fill="#0051C4"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M118.983 514.956C112.016 514.956 106.335 520.638 106.335 527.604C106.335 534.57 112.017 540.251 118.983 540.251C125.949 540.251 131.63 534.57 131.63 527.604C131.63 520.638 125.949 514.956 118.983 514.956ZM126.082 533.688C126.082 533.688 123.447 534.738 123.445 534.739C123.001 534.916 122.455 534.882 122.032 534.643C121.599 534.399 121.301 533.972 121.219 533.482L120.756 530.683C120.608 529.789 121.213 528.944 122.107 528.796C122.514 528.729 122.91 528.819 123.235 529.019C123.386 528.564 123.465 528.086 123.465 527.604C123.465 525.132 121.454 523.121 118.983 523.121C116.511 523.121 114.5 525.132 114.5 527.604C114.5 528.361 114.694 529.111 115.06 529.773C115.498 530.566 115.211 531.565 114.418 532.003C113.625 532.442 112.627 532.154 112.188 531.362C111.554 530.214 111.219 528.915 111.219 527.604C111.219 523.323 114.702 519.84 118.983 519.84C123.264 519.84 126.747 523.323 126.747 527.604C126.747 528.655 126.531 529.694 126.12 530.656C126.507 530.822 126.83 531.135 126.998 531.557C127.334 532.399 126.923 533.353 126.082 533.688Z"
                fill="#0051C4"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M95.9804 528.807C98.4723 528.807 100.861 528.646 103.071 528.352C103.06 528.104 103.053 527.855 103.053 527.604C103.053 522.928 105.079 518.716 108.299 515.799C104.875 514.868 100.604 514.313 95.9804 514.313C84.7718 514.313 75.6299 517.569 75.6299 521.56C75.6299 525.552 84.7718 528.807 95.9804 528.807Z"
                fill="#0051C4"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M80.5006 529.772C78.5386 529.073 76.9074 528.243 75.6407 527.299C75.6407 527.299 75.6406 534.271 75.6406 534.704C75.6406 538.706 84.7519 541.95 95.9913 541.95C101.054 541.95 105.685 541.292 109.245 540.202C106.494 538.071 104.457 535.062 103.559 531.597C101.154 531.92 98.5969 532.089 95.9798 532.089C90.1934 532.089 84.6961 531.266 80.5006 529.772Z"
                fill="#0051C4"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.483 542.919C107.295 544.41 101.793 545.231 95.9922 545.231C90.1909 545.231 84.6895 544.41 80.5015 542.919C78.5387 542.22 76.9076 541.388 75.6417 540.441C75.6417 540.441 75.6416 547.479 75.6416 547.912C75.6416 551.914 84.7529 555.159 95.9922 555.159C107.232 555.159 116.343 551.914 116.343 547.912V543.313C115.163 543.115 114.027 542.788 112.949 542.345C112.483 542.545 111.995 542.736 111.483 542.919Z"
                fill="#0051C4"
              />
            </g>
            <g filter="url(#filter2_i_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 1078.5C109.048 1078.71 106.351 1078.81 103.629 1078.81C46.4674 1078.81 0.128906 1032.47 0.128906 975.312C0.128906 918.151 46.4674 871.812 103.629 871.812C124.168 871.812 143.31 877.795 159.407 888.113C173.432 897.103 188.868 904.812 205.527 904.812H554.129C602.178 904.812 641.129 943.764 641.129 991.812C641.129 1039.86 602.178 1078.81 554.129 1078.81H119.129C116.632 1078.81 114.16 1078.71 111.717 1078.5Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 1078L111.718 1078L111.678 1078C109.022 1078.21 106.338 1078.31 103.629 1078.31C46.7436 1078.31 0.628906 1032.2 0.628906 975.312C0.628906 918.427 46.7436 872.312 103.629 872.312C124.07 872.312 143.118 878.266 159.137 888.534C173.181 897.536 188.718 905.312 205.527 905.312H554.129C601.902 905.312 640.629 944.04 640.629 991.812C640.629 1039.59 601.902 1078.31 554.129 1078.31H119.129C116.646 1078.31 114.188 1078.21 111.759 1078Z"
              stroke="url(#paint2_linear_113_511)"
            />
            <circle
              cx="103.629"
              cy="975.312"
              r="82.5"
              fill="url(#paint3_linear_113_511)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="975.312"
              r="59.1949"
              fill="white"
            />
            <path
              d="M96.8346 976.073L102.659 979.956C102.946 980.148 103.284 980.251 103.63 980.251C103.976 980.251 104.314 980.148 104.601 979.956L110.425 976.073C112.104 974.956 113.481 973.441 114.433 971.662C115.385 969.884 115.882 967.898 115.88 965.881V957.623C115.878 956.687 115.505 955.79 114.844 955.127C114.525 954.809 114.147 954.557 113.731 954.385C113.315 954.214 112.869 954.126 112.418 954.126C111.905 954.13 111.392 954.094 110.884 954.02C108.603 953.656 106.491 952.595 104.837 950.983C104.512 950.673 104.08 950.5 103.63 950.5C103.18 950.5 102.748 950.673 102.422 950.983C100.769 952.595 98.6567 953.656 96.3761 954.02C95.8675 954.09 95.3548 954.125 94.8414 954.126C93.9331 954.13 93.0625 954.49 92.4159 955.127C91.7545 955.79 91.3821 956.687 91.3799 957.623V965.881C91.378 967.898 91.875 969.884 92.8267 971.662C93.7785 973.441 95.1553 974.956 96.8346 976.073ZM98.0176 962.388C98.3458 962.06 98.7908 961.876 99.2549 961.876C99.7189 961.876 100.164 962.06 100.492 962.388L102.755 964.651L106.768 960.638C106.929 960.471 107.122 960.338 107.336 960.246C107.549 960.154 107.779 960.106 108.011 960.104C108.244 960.102 108.474 960.146 108.689 960.234C108.904 960.322 109.1 960.452 109.264 960.616C109.428 960.781 109.558 960.976 109.646 961.191C109.734 961.406 109.778 961.637 109.776 961.869C109.774 962.101 109.726 962.331 109.634 962.545C109.543 962.758 109.409 962.951 109.242 963.113L103.992 968.363C103.664 968.691 103.219 968.875 102.755 968.875C102.291 968.875 101.846 968.691 101.518 968.363L98.0176 964.863C97.6896 964.534 97.5053 964.089 97.5053 963.625C97.5053 963.161 97.6896 962.716 98.0176 962.388ZM128.13 962.75V985.5C128.13 986.893 127.577 988.228 126.592 989.213C125.608 990.197 124.272 990.75 122.88 990.75H84.3799C82.9875 990.75 81.6521 990.197 80.6676 989.213C79.683 988.228 79.1299 986.893 79.1299 985.5V962.75C79.1299 961.358 79.683 960.023 80.6676 959.038C81.6521 958.053 82.9875 957.5 84.3799 957.5H87.8921C87.8921 957.541 87.8799 957.581 87.8799 957.623V965.881C87.877 968.474 88.5159 971.028 89.7398 973.315C90.9636 975.601 92.7343 977.549 94.8939 978.985L100.72 982.87C101.582 983.445 102.595 983.751 103.631 983.751C104.667 983.751 105.68 983.445 106.542 982.87L112.366 978.987C114.526 977.551 116.297 975.602 117.52 973.316C118.744 971.029 119.383 968.475 119.38 965.881V957.623C119.38 957.581 119.368 957.541 119.368 957.5H122.88C124.272 957.5 125.608 958.053 126.592 959.038C127.577 960.023 128.13 961.358 128.13 962.75ZM115.88 997.75C115.876 998.194 115.703 998.62 115.397 998.942C115.09 999.263 114.673 999.456 114.23 999.481L114.245 999.5H93.0599L93.0704 999.488C92.6332 999.445 92.2283 999.238 91.9362 998.91C91.6441 998.582 91.4861 998.156 91.4936 997.717C91.5011 997.278 91.6735 996.857 91.9767 996.539C92.2798 996.221 92.6915 996.029 93.1299 996H95.6744C96.0205 995.45 96.304 994.863 96.5196 994.25H110.735C110.946 994.865 111.229 995.453 111.578 996H114.13C114.594 996 115.039 996.185 115.367 996.513C115.696 996.841 115.88 997.286 115.88 997.75Z"
              fill="#1BB738"
            />
            <g filter="url(#filter3_i_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M715.541 861.501C718.21 861.708 720.907 861.812 723.629 861.812C780.79 861.812 827.129 815.474 827.129 758.312C827.129 701.151 780.79 654.812 723.629 654.812C703.09 654.812 683.948 660.795 667.851 671.113C653.825 680.103 638.39 687.812 621.731 687.812H273.129C225.08 687.812 186.129 726.764 186.129 774.812C186.129 822.861 225.08 861.812 273.129 861.812H708.129C710.626 861.812 713.098 861.707 715.541 861.501Z"
                fill="white"
              />
            </g>
            <path
              d="M715.499 861.003L715.539 861L715.58 861.003C718.236 861.208 720.92 861.312 723.629 861.312C780.514 861.312 826.629 815.198 826.629 758.312C826.629 701.427 780.514 655.312 723.629 655.312C703.188 655.312 684.139 661.266 668.121 671.534C654.077 680.536 638.54 688.312 621.731 688.312H273.129C225.356 688.312 186.629 727.04 186.629 774.812C186.629 822.585 225.356 861.312 273.129 861.312H708.129C710.612 861.312 713.07 861.208 715.499 861.003Z"
              stroke="url(#paint4_radial_113_511)"
            />
            <circle
              cx="82.5"
              cy="82.5"
              r="82.5"
              transform="matrix(-1 0 0 1 806.129 675.812)"
              fill="url(#paint5_linear_113_511)"
            />
            <circle
              opacity="0.9"
              cx="59.1949"
              cy="59.1949"
              r="59.1949"
              transform="matrix(-1 0 0 1 782.823 699.117)"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M723.045 765.313C723.045 763.612 722.368 761.979 721.167 760.775C719.963 759.573 718.329 758.896 716.628 758.896H704.962C703.261 758.896 701.627 759.573 700.423 760.775C699.222 761.979 698.545 763.612 698.545 765.313V776.98C698.545 778.681 699.222 780.314 700.423 781.518C701.627 782.72 703.261 783.396 704.962 783.396H716.628C718.329 783.396 719.963 782.72 721.167 781.518C722.368 780.314 723.045 778.681 723.045 776.98V765.313ZM719.545 765.313V776.98C719.545 777.754 719.237 778.494 718.691 779.042C718.143 779.588 717.403 779.896 716.628 779.896H704.962C704.187 779.896 703.447 779.588 702.899 779.042C702.353 778.494 702.045 777.754 702.045 776.98V765.313C702.045 764.538 702.353 763.799 702.899 763.25C703.447 762.704 704.187 762.396 704.962 762.396H716.628C717.403 762.396 718.143 762.704 718.691 763.25C719.237 763.799 719.545 764.538 719.545 765.313Z"
              fill="#DDCA27"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M748.712 765.313C748.712 763.612 748.035 761.979 746.834 760.775C745.63 759.573 743.996 758.896 742.295 758.896H730.629C728.928 758.896 727.294 759.573 726.09 760.775C724.889 761.979 724.212 763.612 724.212 765.313V776.98C724.212 778.681 724.889 780.314 726.09 781.518C727.294 782.72 728.928 783.396 730.629 783.396H742.295C743.996 783.396 745.63 782.72 746.834 781.518C748.035 780.314 748.712 778.681 748.712 776.98V765.313ZM741.997 772.665C742.543 772.355 742.879 771.774 742.879 771.146C742.879 770.519 742.543 769.938 741.997 769.627L733.83 764.961C733.289 764.65 732.624 764.653 732.085 764.965C731.543 765.28 731.212 765.857 731.212 766.48V775.813C731.212 776.436 731.543 777.012 732.085 777.327C732.624 777.64 733.289 777.642 733.83 777.332L741.997 772.665Z"
              fill="#DDCA27"
            />
            <path
              d="M714.295 768.812C715.261 768.812 716.045 768.029 716.045 767.062C716.045 766.096 715.261 765.312 714.295 765.312C713.328 765.312 712.545 766.096 712.545 767.062C712.545 768.029 713.328 768.812 714.295 768.812Z"
              fill="#DDCA27"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M723.045 739.646C723.045 737.945 722.368 736.312 721.167 735.108C719.963 733.906 718.329 733.229 716.628 733.229H704.962C703.261 733.229 701.627 733.906 700.423 735.108C699.222 736.312 698.545 737.945 698.545 739.646V751.313C698.545 753.014 699.222 754.647 700.423 755.851C701.627 757.053 703.261 757.729 704.962 757.729H716.628C718.329 757.729 719.963 757.053 721.167 755.851C722.368 754.647 723.045 753.014 723.045 751.313V739.646ZM713.404 748.053C713.415 747.976 713.42 747.894 713.42 747.813V743.146H714.003C714.969 743.146 715.753 742.362 715.753 741.396C715.753 740.43 714.969 739.646 714.003 739.646H711.67C710.704 739.646 709.92 740.43 709.92 741.396V744.896C707.988 744.896 706.42 746.464 706.42 748.396C706.42 750.328 707.988 751.896 709.92 751.896C711.852 751.896 713.42 750.328 713.42 748.396C713.42 748.282 713.415 748.167 713.404 748.053Z"
              fill="#DDCA27"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M708.891 773.514L701.676 764.239C701.217 763.649 700.435 763.416 699.728 763.658C699.021 763.901 698.545 764.566 698.545 765.313L700.295 781.063H720.128L721.878 778.146C721.878 777.682 721.694 777.236 721.365 776.909L716.176 771.72C715.231 770.773 713.761 770.593 712.613 771.281L708.891 773.514Z"
              fill="#DDCA27"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M748.712 739.646C748.712 737.945 748.035 736.312 746.834 735.108C745.63 733.906 743.996 733.229 742.295 733.229H730.629C728.928 733.229 727.294 733.906 726.09 735.108C724.889 736.312 724.212 737.945 724.212 739.646V751.313C724.212 753.014 724.889 754.647 726.09 755.851C727.294 757.053 728.928 757.729 730.629 757.729H742.295C743.996 757.729 745.63 757.053 746.834 755.851C748.035 754.647 748.712 753.014 748.712 751.313V739.646ZM731.795 750.729H741.129C742.095 750.729 742.879 749.945 742.879 748.979C742.879 748.013 742.095 747.229 741.129 747.229H731.795C730.829 747.229 730.045 748.013 730.045 748.979C730.045 749.945 730.829 750.729 731.795 750.729ZM731.795 743.729H737.629C738.595 743.729 739.379 742.945 739.379 741.979C739.379 741.013 738.595 740.229 737.629 740.229H731.795C730.829 740.229 730.045 741.013 730.045 741.979C730.045 742.945 730.829 743.729 731.795 743.729Z"
              fill="#DDCA27"
            />
            <g filter="url(#filter4_i_113_511)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M717.541 424.501C720.21 424.708 722.907 424.812 725.629 424.812C782.79 424.812 829.129 378.474 829.129 321.312C829.129 264.151 782.79 217.812 725.629 217.812C705.09 217.812 685.948 223.795 669.851 234.113C655.825 243.103 640.39 250.812 623.731 250.812H275.129C227.08 250.812 188.129 289.764 188.129 337.812C188.129 385.861 227.08 424.812 275.129 424.812H710.129C712.626 424.812 715.098 424.707 717.541 424.501Z"
                fill="white"
              />
            </g>
            <path
              d="M717.499 424.003L717.539 424L717.58 424.003C720.236 424.208 722.92 424.312 725.629 424.312C782.514 424.312 828.629 378.198 828.629 321.312C828.629 264.427 782.514 218.312 725.629 218.312C705.188 218.312 686.139 224.266 670.121 234.534C656.077 243.536 640.54 251.312 623.731 251.312H275.129C227.356 251.312 188.629 290.04 188.629 337.812C188.629 385.585 227.356 424.312 275.129 424.312H710.129C712.612 424.312 715.07 424.208 717.499 424.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="724.629"
              cy="321.312"
              r="82.5"
              fill="url(#paint6_linear_113_511)"
            />
            <circle
              opacity="0.9"
              cx="724.629"
              cy="321.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip2_113_511)">
              <path
                d="M706.557 312.771C707.442 312.771 708.299 312.654 709.115 312.436L715.34 318.661L722.313 311.669L716.097 305.454C717.824 299.32 712.954 292.924 706.557 293.022C693.473 293.505 693.475 312.289 706.557 312.771ZM703.955 300.294L707.51 299.342L710.112 301.944L709.16 305.499L705.605 306.451L703.003 303.849L703.955 300.294Z"
                fill="#E04713"
              />
              <path
                d="M742.765 329.23C741.88 329.23 741.023 329.346 740.208 329.565C739.557 328.915 735.065 324.422 733.95 323.307L726.977 330.299L733.225 336.547C731.498 342.681 736.368 349.077 742.765 348.979C755.849 348.496 755.847 329.712 742.765 329.23ZM745.367 341.707L741.812 342.659L739.21 340.057L740.163 336.502L743.717 335.55L746.32 338.152L745.367 341.707Z"
                fill="#E04713"
              />
              <path
                d="M740.144 312.434C748.214 314.639 755.249 306.159 751.612 298.639L746.191 304.06L742.7 302.896L741.536 299.405L746.957 293.984C739.431 290.346 730.957 297.387 733.162 305.452L709.114 329.566C701.044 327.36 694.009 335.84 697.646 343.361L703.067 337.94L706.558 339.104L707.722 342.595L702.301 348.016C709.827 351.654 718.301 344.613 716.096 336.548L740.144 312.434Z"
                fill="#E04713"
              />
            </g>
            <path
              d="M285.129 11.8125H558.129C618.328 11.8125 667.129 60.6135 667.129 120.812C667.129 181.012 618.328 229.812 558.129 229.812H272.129C211.93 229.812 163.129 278.613 163.129 338.812C163.129 399.012 211.93 447.812 272.129 447.812H558.129C618.328 447.812 667.129 496.613 667.129 556.812C667.129 617.012 618.328 665.812 558.129 665.812H272.129C211.93 665.812 163.129 714.613 163.129 774.812C163.129 835.012 211.93 883.812 272.129 883.812H558.129C618.328 883.812 667.129 932.613 667.129 992.812C667.129 1053.01 618.328 1101.81 558.129 1101.81H272.129"
              id="filling_path"
              stroke="url(#paint7_linear_113_511)"
              stroke-width="20"
              stroke-linecap="round"
            />
            <defs>
              <filter
                id="filter0_i_113_511"
                x="0.128906"
                y="0.8125"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_113_511"
                />
              </filter>
              <filter
                id="filter1_i_113_511"
                x="0.128906"
                y="437.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_113_511"
                />
              </filter>
              <filter
                id="filter2_i_113_511"
                x="0.128906"
                y="871.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_113_511"
                />
              </filter>
              <filter
                id="filter3_i_113_511"
                x="186.129"
                y="654.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_113_511"
                />
              </filter>
              <filter
                id="filter4_i_113_511"
                x="188.129"
                y="217.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_113_511"
                />
              </filter>
              <linearGradient
                id="paint0_linear_113_511"
                x1="103.629"
                y1="21.8125"
                x2="103.629"
                y2="186.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#1B91DA" />
                <stop offset="1" stop-color="#0E4D74" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_113_511"
                x1="103.629"
                y1="458.812"
                x2="103.629"
                y2="623.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#0065F4" />
                <stop offset="1" stop-color="#0F4798" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_113_511"
                x1="665.536"
                y1="871.812"
                x2="9.05439"
                y2="871.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#21D342" />
                <stop offset="1" stop-color="#258136" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_113_511"
                x1="103.629"
                y1="892.812"
                x2="103.629"
                y2="1057.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#21D342" />
                <stop offset="1" stop-color="#258136" />
              </linearGradient>
              <radialGradient
                id="paint4_radial_113_511"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(506.629 758.312) rotate(90) scale(103.5 320.5)"
              >
                <stop stop-color="#FFE81E" />
                <stop offset="1" stop-color="#C4B214" />
              </radialGradient>
              <linearGradient
                id="paint5_linear_113_511"
                x1="82.5"
                y1="0"
                x2="82.5"
                y2="165"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFE81E" />
                <stop offset="1" stop-color="#C4B214" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_113_511"
                x1="724.629"
                y1="238.812"
                x2="724.629"
                y2="403.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FC490B" />
                <stop offset="1" stop-color="#C7471A" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_113_511"
                x1="412.434"
                y1="2191.81"
                x2="412.434"
                y2="3063.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#09C2C1" />
                <stop offset="1" stop-color="#1D85D8" />
              </linearGradient>
              <clipPath id="clip0_113_511">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(75.6299 76.3125)"
                />
              </clipPath>
              <clipPath id="clip1_113_511">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(75.6299 513.312)"
                />
              </clipPath>
              <clipPath id="clip2_113_511">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(696.629 293)"
                />
              </clipPath>
            </defs>
          </svg>

          <div className="content_detail">
            <div className="col_detail  ">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mainflow1.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/regular-updates"> Regular Updates</a>
               
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#004875;" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
                Implement new features and security patches to keep your website
                modern.
              </p>
            </div>
            <div className="col_detail  ">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mainflow2.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/bugfixes-performance-optimization">Bug Fixes & Performance Optimization</a>
                
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#C7471A;" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
                Ensure your website runs smoothly and loads quickly.
              </p>
            </div>
            <div className="col_detail  ">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mainflow3.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/backup-recovery">Backup & Recovery</a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#0F4798;" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
                Protect your website with regular data backups and efficient
                recovery options.
              </p>
            </div>
            <div className="col_detail  ">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mainflow4.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/content-updates">Content Updates</a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#004875;" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
                Keep your website fresh with updated visuals, text, and
                features.
              </p>
            </div>
            <div className="col_detail  ">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mainflow5.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/security-monitoring"> Security Monitoring</a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#C7471A;" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
                Safeguard against threats with proactive monitoring and
                mitigation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDevFlow;
